export enum CounterUseFor {
    bills = 'bills',
    invoices = 'invoices',
}

export const CounterFormField = {
    Name: 'name',
    StartValue: 'startValue',
    NumberFormat: 'numberFormat',
    BillTypeCode: 'billTypeCode',
    IsDefault: 'isDefault',
    IsDefaultForCreditNotes: 'isDefaultForCreditNotes',
    Title: 'title',
    UseFor: 'useFor',
    Prefix: 'prefix',
    NumberOfDigits: 'numberOfDigits',
    Created: 'created',
    Updated: 'updated',
    DisplayCID: 'displayCID',
    CreditNoteTitle: 'creditNoteTitle',
    CounterId: 'counterId',
} as const;
